<template>
    <v-content>
      <v-container fluid>
        <Header :title="title" />
        <v-row no-gutters>
          <v-col cols="12">

            <v-tabs
            v-model="tabs"
          >
              <v-tabs-slider></v-tabs-slider>
              <v-tab v-if="canAdd" href="#viewresource"> {{ 'Additional Pages' | translate}} </v-tab>
              <v-tab v-if="canAddAdditionalResource" href="/resources" active> {{ 'Resources' | translate}} </v-tab>
          </v-tabs>

            <DataTable
              @editing="editing"
              @deleting="deleting"
              :title="''"
              :headers="headers"
              :items="additionalpages"
              :search="search"
            />
          </v-col>
          <Dialogbox
            @closing="closing"
            @deleteuser="deleteQuiz"
            :title="dialogboxtitle"
            :dialog="dialogstatus"
            :buttonTitle="dialogButtontitle"
            :deleteuser="true"
            v-if="dialogstatus"
          />
        </v-row>
      </v-container>
      <v-btn dark fab fixed bottom right large color="pink" class="mx-2" v-if="canAdd" @click="addQuiz">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-content>
  </template>
  
  <script>
  import { mapGetters } from "vuex"
  import store from "@/store"
  import {
    FETCH_ADDITIONAL_PAGES,
    DELETE_ADDITIONAL_PAGE,
    RESET_STATE
  } from "@/store/actions.type";
  import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
  export default {
    name: "additionalPages",
    beforeRouteEnter(to, from, next) {
      store.dispatch(RESET_STATE)
      store.dispatch(FETCH_ADDITIONAL_PAGES, "?replace_content=true").then(resp => {
        if (resp.success) {
          store.commit(SET_LOADING, false)
          store.commit(SET_ROUTER_ENTER, false)
        }
      });
      return next();
    },
    beforeRouteLeave(to, from, next) {
      store.dispatch(RESET_STATE)
      next();
    },
    data: function() {
      return {
        title: "Additional Pages",
        search: "",
        dialogstatus: false,
        dialogButtontitle: null,
        dialogboxtitle: null,
        page_id: null,
        singleSelect: "",
        dialog: false,
        tabs:null,
      };
    },
    components: {
      DataTable: () => import("@/components/datatable/datatable"),
      Dialogbox: () => import("@/components/dialog/dialog"),
      Header: () => import("@/components/header/Header")
    },
    computed: {
      ...mapGetters(["additionalpages",'currentUser']),
      headers () {
        return [
          { text: this.$t("Page Id"), value: "page_id" },  
          { text: this.$t("Page Name"), value: "page_names[0].page_name" },        
          { text: this.$t("Page Type"), value: "page_type" },        
          { text: this.$t("Actions"), value: "action", sortable: false }
        ]
      },
      canAdd(){
        if(typeof this.currentUser !== 'undefined') {
          if(this.currentUser.permissions.includes('has-access-to-additional-pages') || this.currentUser.roles.includes(1)){
            return true;
          }
        }
        return false;
      },
      canAddAdditionalResource(){
        if(typeof this.currentUser !== 'undefined') {
          if(this.currentUser.permissions.includes('has-access-to-additional-pages-resource') || this.currentUser.roles.includes(1)){
            return true;
          }
        }
        return false;
      },
    },
    methods: {
      addQuiz() {
        this.$router.push("/additional-pages/add");
      },
      editing(id) {
        this.$router.push("/additional-pages/edit/" + id)
      },
      deleting(id) {
        this.dialogstatus = true
        this.dialogboxtitle = "Are you sure want to remove?"
        this.dialogButtontitle = "Remove"
        this.page_id = id
      },
      async deleteQuiz() {
        await this.$store
          .dispatch(DELETE_ADDITIONAL_PAGE, this.page_id)
          .then(async resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.page_id = null;
              await store.dispatch(FETCH_ADDITIONAL_PAGES, "?replace_content=true").then(resp => {
                if (resp.success) {
                  store.commit(SET_LOADING, false);
                  this.dialogstatus = false;
                }
              });
            }
            else{
              store.commit(SET_LOADING, false);
            }
          });
      },
      closing() {
        this.dialogstatus = false
      },
    }
  };
  </script>